define('views/modules/calendar/calendar/summary/summary-tables/summary-header',[
    // Libs
    'underscore',
    'backbone',
    'mustache',
    'utils',
    'moment',
    // events
    // Collections

    // views
    // Templates
    'text!templates/modules/calendar/calendar/summary/summary-tables/summary-header.html',
], function(
    // libs
    _, Backbone, Mustache, U, moment,
    // events
    // Collections and models

    // views
    // templates
    TSummaryHeader
) {

    var VSummaryHeader = Backbone.View.extend({
        template: TSummaryHeader,
        events: {

        },

        regions: {
            root: "thead.summary-header"
        },

        initialize: function(opt) {
            this.options = opt || {};
            this.headers = this.options.headers;
        },

        render: function() {

            // Render HTML template
            this.$el.empty().append(Mustache.render(this.template, Mustache.getContext(this.options)));

            // caching element into this.zone
            this.generateZones();

            return this;
        },

    });

    return VSummaryHeader;

});

